import { z } from "zod";
export const DTOForgeProjectRoom = z.object({
    id: z.string(),
});
export const DTOForgeProjectRoomResponse = z.object({
    room: DTOForgeProjectRoom,
});
